import { useEffect } from 'react';
import { unloadAnalytics } from '../analytics';
import { initialize } from '../trackers';
/**
 * Initializes the user behavior tracking
 *
 * This must be called once in the application preferably in the root component
 * If your app is using ServiceProvider, it is already called for you
 *
 * @param options The options for the user behavior tracking. It might either be:
 * - undefined, in which case the tracker is enabled with default options
 * - a boolean [true] which enables the tracker with default options
 * - a boolean [false] which disables the tracker
 * - an object with the options for the tracker
 */

export var useBehaviourAutoTracking = function useBehaviourAutoTracking(options) {
  useEffect(function () {
    initialize(options);
    return unloadAnalytics;
  }, [JSON.stringify(options)]); //Checking for object is re triggering this logic multiple times
};